import { createContext } from 'react'

const FirstTimeContext = createContext({})

export default FirstTimeContext
